var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5984 6.4002C10.0468 6.4002 9.59844 5.9518 9.59844 5.4002C9.59844 4.8486 10.0468 4.4002 10.5984 4.4002C11.15 4.4002 11.5984 4.8486 11.5984 5.4002C11.5984 5.9518 11.15 6.4002 10.5984 6.4002ZM11.7992 3.2002H9.26202C8.78122 3.2002 8.32882 3.3874 7.98922 3.7274L3.54002 8.1762C3.32322 8.393 3.19922 8.693 3.19922 9.001C3.19922 9.3074 3.32322 9.6074 3.54002 9.8242L6.17522 12.459C6.39202 12.6758 6.69202 12.8002 7.00002 12.8002C7.30602 12.8002 7.60602 12.6758 7.82282 12.459L12.272 8.0102C12.612 7.6706 12.7992 7.2182 12.7992 6.7374V4.2002C12.7992 3.6486 12.3508 3.2002 11.7992 3.2002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrand);
export default __webpack_public_path__ + "static/media/brand.6d09149e583bfe93d62edc9fdb476735.svg";
export { ForwardRef as ReactComponent };